import WIDGETS from './widgets';

export default {
  name: 'admin_schedulers',
  spacing: 2,
  widgets: [
    { content: WIDGETS.SCHEDULERS_LIST, breakpoints: { xs: 12, sm: 12 }, lazy_loading: 0 },
  ],
};
